exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "md-card {\n  margin: 0.1em auto;\n}\n\nmd-card-content {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.wa9004-input {\n  width: 600px;\n}\n\n.wa9004-select {\n  width: 250px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9004/wa9004.component.css
// module id = ../../../../../src/app/pages/wa9Master/wa9004/wa9004.component.css
// module chunks = main